
// to check if main.js is loaded in the browser at all
// console.info('Let the games begin - Hello main.js! :)');

// import some (vendor) libs
import $ from "jquery";
import Slick from "slick-carousel";
import Scroll from "smooth-scroll";
import Nouislider from "nouislider";
import InfiniteScroll from "infinite-scroll";
import viewportUnitsBuggyfill from "viewport-units-buggyfill";

//import Foundation from 'foundation-sites';

window.jQuery = $;
window.$ = $;

// import / include the class definition
import Bvi from "./modules/Bvi.js";
import Filter from "./modules/Filter.js";
import TeaserCount from "./modules/TeaserCount.js";
import BviFilter from "./modules/BviFilter.js";
import mySliderReveal from "./modules/SliderReveal.js";
import myReveal from "./modules/Reveal.js";
import mySearchsolr from "./modules/Searchsolr.js";
import myRentenlueckenrechnerForm from "./modules/RentenlueckenrechnerForm.js";

require("../../../../../../node_modules/foundation-sites/dist/js/foundation.min.js");
//require('../../../../../../../../node_modules/scrollmagic/scrollmagic/uncompressed/ScrollMagic.js');
import myFormListen from "./modules/FormListenEvent.js";

import ScrollMagic from "scrollmagic";

import {
	TweenLite,
	TimelineLite
} from "gsap";

import "imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators";
import "imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap";

// let's create our own instance and say something
let bvi = new Bvi();
let filter = new Filter();
let bvifilter = new BviFilter();
let startFormListen = new myFormListen();
let startTeaserCount = new TeaserCount();
let startSliderReveal = new mySliderReveal();
let startReveal = new myReveal();
let startSearchsolr = new mySearchsolr();
let startRentenlueckenrechnerForm = new myRentenlueckenrechnerForm();

// init controller
let controller = new ScrollMagic.Controller();

/**
 *
 * Let the games begin! This is the very entry point of our app / website js.
 *
 *
 */

function resizeHeaderOnScroll() {
	const distanceY = window.pageYOffset || document.documentElement.scrollTop,
		shrinkOn = 10,
		headerEl = document.getElementById("header") ?
		document.getElementById("header") :
		document.body;
	filter = document.getElementById("filter");

	if (distanceY > shrinkOn) {
		headerEl.classList.add("smaller");
		headerEl.classList.remove("initial");

		if (filter) {
			filter.classList.add("smaller");
		}
	} else {
		headerEl.classList.remove("smaller");
		headerEl.classList.add("initial");

		if (filter) {
			filter.classList.remove("smaller");
		}
	}
}

function print_error_message(type_error, original_error) {
	console.error('Code error: ' + type_error);
	console.error(original_error.message);
}

// see http://gregfranko.com/jquery-best-practices/#/4 - TODO: maybe try an IIFE (Immediately Invoked Function Expression) approach
$(function () {

	try {
		// initialize foundation
		$(document).foundation();
		startFormListen.init();
		startTeaserCount.init();
		startSliderReveal.init();
		startReveal.init();
		startRentenlueckenrechnerForm.init();
	} catch (type_error) {
		print_error_message('Some modules', type_error);
	}

	try {
		// Scrolling to an anchor link on another page
		if (window.location.hash.match(/^#c[0-9]+$/)) { // check active anchor
			console.log('anchor url');
			let scroll = new Scroll();
			let anchor = document.querySelector(window.location.hash); // init anchor
			scroll.animateScroll(anchor, anchor, {offset: window.outerWidth < 767 ? 50 : 70,}); // active animate scrolling
		}

		// init smooth scroll
		var scroll = new Scroll('a[href*="#"]', {
			offset: window.outerWidth < 767 ?
				50 :
				70,
			// Selectors
			ignore: '[data-scroll-ignore]', // Selector for links to ignore (must be a valid CSS selector)
			updateURL: false, // Update the URL on scroll

		});
	} catch (type_error) {
		print_error_message('smoothScroll', type_error);
	}

	try {
		//check scrolling to active some changes in header or body
		window.addEventListener("scroll", resizeHeaderOnScroll);
	} catch (type_error) {
		print_error_message('HeaderScroll', type_error);
	}

	// ignore user agent force initialization
	// active only on tablet and mobile
	if (window.innerWidth < 1024) {
		viewportUnitsBuggyfill.init({
			force: true,
			refreshDebounceWait: 99999999999, // refresh only once
		});
	}

	$(".slider-hero").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		infinite: true,
		autoplay: true,
    autoplaySpeed: 8000,
    pauseOnHover: false,
    pauseOnFocus: false
	});

	$(".slider-member").slick({
		rows: 4,
		dots: true,
		arrows: true,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 3000,
		slidesToShow: 3,
		slidesToScroll: 3,
		responsive: [{
				breakpoint: 769,
				settings: {
					slidesPerRow: 3,
					rows: 3,
					slidesToScroll: 1,
					slidesToShow: 1,
					dots: true,
				},
			},
			{
				breakpoint: 480,
				settings: {
					rows: 3,
					slidesPerRow: 2,
					slidesToScroll: 1,
					slidesToShow: 1,
					dots: false,
				},
			},
		],
	});

	$(".slider-member--tworows").slick({
		rows: 1,
		dots: true,
		arrows: true,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 3000,
		slidesToShow: 5,
		slidesToScroll: 1,
		responsive: [{
				breakpoint: 769,
				settings: {
					slidesToScroll: 1,
					slidesToShow: 4,
					dots: false,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToScroll: 1,
					slidesToShow: 2,
					dots: false,
				},
			},
		],
	});

	try {
		bvi.go();
	} catch (type_error) {
		print_error_message('BVI module', type_error);
	}
	try {
		filter.go();
	} catch (type_error) {
		print_error_message('Filter module', type_error);
	}

	// multiple range slider
	var startSlider = document.getElementById("allocated");
	if (startSlider != null) {
		Nouislider.create(startSlider, {
			start: [35, 65],
			step: 1,
			connect: [true, true, true],
			range: {
				min: 0,
				max: 100,
			},
		});

		//noUiSlider's connect elements can be individually colored or otherwise styled.
		var connect = startSlider.querySelectorAll(".noUi-connect");
		var classes = [
			"slider-fill--darkblue",
			"slider-fill--blue",
			"slider-fill--green",
		];

		for (var i = 0; i < connect.length; i++) {
			connect[i].classList.add(classes[i]);
		}
		// method is useful for synchronizing with input
		startSlider.noUiSlider.on("update", function (values, handle) {
			$(".retirement__allocated .allocated__number").each(function (
				index,
				element
			) {
				$(element).text(Math.ceil(values[0]));
				if ($(element).hasClass("allocated__number--blue")) {
					$(element).text(Math.ceil(Math.abs(values[0] - values[1])));
				}

				if ($(element).hasClass("allocated__number--green")) {
					$(element).text(Math.ceil(100 - values[1]));
				}
			});
		});

		// method is useful for synchronizing with input of foundation
		$(".slider").on("load moved.zf.slider changed.zf.slider", function () {
			$(".input__number").each(function (index, element) {
        if( $(element).val().length > 3 ) {
          if(document.documentElement.lang == "de") {
            $(element).text(
              $(element)
              .val()
              .toString()
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
            );
          }
          else {
            $(element).text(
              $(element)
              .val()
              .toString()
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
            );
          }
        }
         else {
          if(document.documentElement.lang == "de") {
            $(element).text($(element).val().replace('.', ','));
          }
          else {
            $(element).text($(element).val());
          }
         }
			});
		});
	}

	$("#menuButton").click(function () {
		$(this).toggleClass("open");
		$("#menu").toggleClass("open");
		$("#header").toggleClass("open");
	});

	//open search
	$("#searchButton").click(function () {
		$("#search").toggleClass("active");
		$("#header").toggleClass("active-search");
		$("body").toggleClass("not-scroll");
	});

	//close search
	$("#search .close-search").click(function () {
		$("#search").toggleClass("active");
		$("#header").toggleClass("active-search");
		$("body").toggleClass("not-scroll");
	});

	// init infinite scroll to fond results
	var elem = document.querySelector(".fonds-results__scroll");
	if (elem != null) {
		$(".item__fondsuche").on("click", function (event) {
			$(this).toggleClass("is-open");
		});

		new InfiniteScroll(elem, {
			// options
			path: ".paginate__next",
			append: ".item",
			history: false,
		});
	}

	// init infinite scroll to positions
	var elem1 = document.querySelector(".position__scroll");
	if (elem1 != null) {
		new InfiniteScroll(elem1, {
			// options
			path: ".next-items",
			append: ".teaser",
			history: false,
			hideNav: ".f3-widget-paginator",
		});
	}

  // init infinite scroll to news
  var newsScroller = document.querySelector(".news__scroll");
  if (newsScroller != null) {
    new InfiniteScroll(newsScroller, {
      // options
      path: ".next-items",
      append: ".teaser",
      history: false,
      status: '.page-load-status',
      hideNav: ".f3-widget-paginator",
    });
  }

	// Attaches click event handlers to .item__fondsuche
	if (elem != null) {
		$(window).on("scroll load.infiniteScroll", function () {
			$(".item__fondsuche").off("click"); //remove event handlers attached
			// updated click event to item fondsuche
			$(".item__fondsuche").on("click", function (event) {
				$(this).toggleClass("is-open");
			});
		});

		if (document.querySelector(".fonds-results__scroll")) {
			var elem = document.querySelector(".fonds-results__scroll");
			var infScroll = new InfiniteScroll(elem, {
				// options
				path: ".paginate__next",
				append: ".item",
				history: false,
			});

			// Attaches click event handlers to .item__fondsuche
			if (elem != undefined) {
				$(window).on("scroll load.infiniteScroll", function () {
					$(".item__fondsuche").off("click"); //remove event handlers attached
					// updated click event to item fondsuche
					$(".item__fondsuche").on("click", function (event) {
						$(this).toggleClass("is-open");
					});
				});
			}
		}
	}

	// change back speech to home or last link
	if ($(".ce-speech__back").length) {
		if (history.length > 2) {
			// remove home link and active back to the last link
			$(".ce-speech__back").addClass("to_back");
		} else {
			// active home link
			$(".ce-speech__back").addClass("to_home");
			$(".ce-speech__back").attr("href", "/");
		}
	}
});

let scene = new ScrollMagic.Scene({
		triggerHook: 0.5,
		duration: 1000,
	})
	.setTween(".hero__overlay", {
		opacity: "1",
	}) // the tween durtion can be omitted and defaults to 1
	// .addIndicators({name: "2 (duration: 600)"}) // add indicators (requires plugin)
	.addTo(controller);

let scene2 = new ScrollMagic.Scene({
		triggerHook: 0.5,
		duration: 1000,
	})
	.setTween(".hero__text", {
		transform: "translateY(50px)",
	}) // the tween durtion can be omitted and defaults to 1
	// .addIndicators({name: "2 (duration: 1000)"}) // add indicators (requires plugin)
	.addTo(controller);

// sample Include to demonstrate the function of Entsparrechner.js

import Entsparrechner from "./modules/Entsparrechner.js";

let EntsparrechnerInstanz = new Entsparrechner();
EntsparrechnerInstanz.main();
